import { ElementRef, Injectable } from '@angular/core';

export interface WindowComponentInjector {
    workarea: ElementRef;
}

@Injectable({ providedIn: 'root' })
export class windowReferenceService {
    private injectedElements: WindowComponentInjector;

    public init(elements: WindowComponentInjector) {
        const injectionCopy = {};
        for (const index in elements) {
            injectionCopy[index] = elements[index];
        }
        this.injectedElements = injectionCopy as WindowComponentInjector;
    }

    getWorkArea(): ElementRef {
        return this.injectedElements.workarea;
    }

    getEditorContainer(): HTMLElement {
        return document.querySelector('#editorContainer');
    }

    getCanvasBackground(): HTMLElement {
        return document.getElementById('canvasBackground');
    }

    getSvgContentElement() {
        return document.getElementById('svgcontent');
    }
}
